export default __webpack_public_path__ + "static/media/plurvid.1dc96d5d.MP4";